import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingCircularPanelService {
  private isLoadingCircularPanelVisibleSubject = new Subject<boolean>();

  isLoadingCircularPanelVisible$ =
    this.isLoadingCircularPanelVisibleSubject.asObservable();

  toggleLoadingCircularPanelVisibility(visible: boolean): void {
    this.isLoadingCircularPanelVisibleSubject.next(visible);
  }
}
